export const METADATA_TYPE = '@type';
export const TYPE = [METADATA_TYPE];